import { render, staticRenderFns } from "./fvContent.vue?vue&type=template&id=63bcd47c&lang=pug&"
var script = {}
import style0 from "./fvContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvContent.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvContent.vue
// module id = 86
// module chunks = 0 1